import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type SetCompanyPhonesRequest as SchemaSetCompanyPhonesRequest } from '../schemas/SetCompanyPhonesRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const SetCompanyPhonesContentType = 'application/json' as const;
export type SetCompanyPhonesRequest = SchemaSetCompanyPhonesRequest;
export type SetCompanyPhonesResponses = LinkCommonErrorResponses & {};
export type SetCompanyPhonesResponseSuccess = undefined;
export type SetCompanyPhonesSearchParams = undefined;
export type SetCompanyPhonesPathParameters = undefined;
export const SetCompanyPhonesUrl = '/company/phones' as const;
export const SetCompanyPhonesMethod = 'POST' as const;
export const getSetCompanyPhonesUrl = (_params?: SetCompanyPhonesPathParameters) => SetCompanyPhonesUrl;
